"use client";

import { ButtonDark, ButtonTransparent, MdButton } from "@/stories/Button.stories";
import { countries_list_german } from "@/utils";
import { Autocomplete, Checkbox, Group, Radio, Stepper } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm, zodResolver } from "@mantine/form";
import { useState } from "react";
import { z } from "zod";
import BackButton from "../BackButton";
import Button from "../Cards/Button";
import ErrorModal from "../ErrorModal";
import { TextInput } from "../Inputs/TextInput";
import InfoModal from "../Modal";
import Text from "../Text/Text";
import dayjs from "dayjs";

export default function BestellungFernbehandlungLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [step, setStep] = useState(1);
    const [openModal, setOpenModal] = useState(false);

    const [active, setActive] = useState(0);
    const nextStep = () =>
        setActive((current) => {
            if (form.validate().hasErrors) {
                return current;
            }
            return current < 3 ? current + 1 : current;
        });
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));
    let schema = z.object({});
    if (step === 3) {
        schema = schema.extend({
            agreeCon: z.boolean().refine((value) => value === true, {
                message: "Bitte akzeptieren Sie die AGB und Widerrufsbelehrung",
            }),
            agree: z.boolean().refine((value) => value === true, {
                message: "Bitte akzeptieren ",
            }),
        });
    }
    const form = useForm({
        initialValues: {
            treated: "",
            reason: "",
            startDate: "",
            andrede: "",
            andredePay: "",
            name: "",
            surname: "",
            alreadyCustomer: false,
            namePay: "",
            surnamePay: "",
            email: "",
            address: "",
            plz: "",
            location: "",
            country: "",
            agreeCon: false,
            agree: false,
        },
        validate: zodResolver(schema),
    });
    const [error, setError] = useState(true);
    return (
        <>
            <div className="container px-3 lg:mx-auto my-40 max-w-10xl">
                <div className="flex justify-between px-1 py-5">
                    <BackButton
                        link="/de/bestellen"
                        title=" Ich bestelle das Fernbehandlungs-Abo"
                    />
                </div>
                <h1 className="text-black text-xl3 px-2 py-3 lg:px-0 lg:text-5xl font-bold  leading-7 lg:leading-14">
                    Ich bestelle das Fernbehandlungs-Abo
                </h1>
                <form
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            treated: values.treated,
                            reason: values.reason,
                            startDate: dayjs(values.startDate).format("DD.MM.YYYY"),
                            andrede: values.andrede,
                            andredePay: values.andredePay,
                            name: values.name,
                            surname: values.surname,
                            alreadyCustomer: values.alreadyCustomer,
                            namePay: values.namePay,
                            surnamePay: values.surnamePay,
                            email: values.email,
                            address: values.address,
                            plz: values.plz,
                            location: values.location,
                            country: values.country,
                            agreeCon: values.agreeCon,
                            agree: values.agree,
                        };

                        sendEmail("Bestellung Fernbehandlung", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch(() => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                    })}
                >
                    <Stepper active={active} color="dark">
                        <Stepper.Step onClick={() => setActive(0)}>
                            <div className="space-y-3 lg:px-0 px-2">
                                <div className="text-neutral-800  text-2xl lg:text-xl3 font-bold  leading-10">
                                    Monatliche Kosten:
                                </div>
                                <div className="text-black  text-lg lg:text-xl1 font-normal  leading-8.5">
                                    CHF 68.00 / EUR 70.00, monatlich kündbar
                                </div>
                                <div className="text-neutral-800 text-lg lg:text-xl1 font-bold  leading-8.5">
                                    Fernbegleitung für:
                                </div>
                                <Radio.Group
                                    name="treated"
                                    id="treated"
                                    {...form.getInputProps("treated")}
                                >
                                    <Group mt="xs">
                                        <Radio value="Mich" label="Mich" />
                                        <Radio value="Andere" label="Andere" />
                                    </Group>
                                </Radio.Group>

                                {form.values.treated === "Andere" && (
                                    <>
                                        <div className="text-neutral-800 text-xl font-bold  leading-8.5">
                                            Anrede
                                        </div>
                                        <Radio.Group
                                            id="andrede"
                                            name="andrede"
                                            {...form.getInputProps("andrede")}
                                        >
                                            <Group mt="xs">
                                                <Radio value="Frau" label="Frau" />
                                                <Radio value="Herr" label="Herr" />
                                                <Radio value="Divers" label="Divers" />
                                            </Group>
                                        </Radio.Group>
                                        <div className="space-y-3 pt-3">
                                            <TextInput
                                                id="name"
                                                name="name"
                                                type="text"
                                                label="Vorname"
                                                placeholder="Hier eingeben"
                                                {...form.getInputProps("name")}
                                            />
                                            <TextInput
                                                id="sunname"
                                                name="surname"
                                                type="text"
                                                label="Nachname"
                                                placeholder="Hier eingeben"
                                                {...form.getInputProps("surname")}
                                            />
                                        </div>
                                    </>
                                )}
                                <div>
                                    <TextInput
                                        type="textarea"
                                        id="reason"
                                        name="reason"
                                        label="Begleitungsgrund (optional)"
                                        placeholder="Hier eingeben"
                                        {...form.getInputProps("reason")}
                                    />

                                    <div className=" text-zinc-600 text-sm font-normal  leading-tight">
                                        Wenn du möchtest, kannst du hier den
                                        Begleitungsgrund deiner aktuellen Situation in
                                        Stichworten schildern. Für mich ist diese
                                        Information aber nicht notwendig, um an den
                                        Ursachen arbeiten zu können.
                                    </div>
                                </div>
                                <div>
                                    <p className="grow shrink basis-0 text-neutral-800 lg:text-lg text-base font-bold  leading-tight">
                                        Start der Fernbehandlung
                                    </p>
                                    <DateInput
                                        valueFormat="DD.MM.YYYY"
                                        label=""
                                        className="border-2 border-black"
                                        placeholder="Start der Fernbehandlung"
                                        id="startDate"
                                        name="startDate"
                                        minDate={new Date()}
                                        {...form.getInputProps("startDate")}
                                    />
                                </div>

                                <div className="flex justify-end">
                                    <Button
                                        backgroundColor={
                                            ButtonDark.args?.backgroundColor
                                        }
                                        hasIcon={ButtonDark.args?.hasIcon}
                                        size={ButtonDark.args?.size}
                                        textSize={ButtonDark.args?.textSize}
                                        text="Weiter"
                                        border={ButtonDark.args?.border}
                                        rounded={ButtonDark.args?.rounded}
                                        onClick={() => {
                                            setStep(2);
                                            nextStep();
                                        }}
                                        buttonType="button"
                                    />
                                </div>
                            </div>
                        </Stepper.Step>
                        <Stepper.Step onClick={() => setActive(1)}>
                            <div className="space-y-3 px-3">
                                <div>
                                    <div className="text-neutral-800 text-xl3 font-bold  leading-10">
                                        Rechnungsadresse
                                    </div>
                                </div>
                                <Checkbox
                                    label="Ich bin bereits Kunde"
                                    id="alreadyCustomer"
                                    name="alreadyCustomer"
                                    {...form.getInputProps("alreadyCustomer")}
                                    size="md"
                                />

                                {form.values.alreadyCustomer !== true && (
                                    <>
                                        <div className="text-neutral-800 text-xl1 font-bold  leading-8.5">
                                            Anrede
                                        </div>
                                        <Radio.Group
                                            id="andredePay"
                                            name="andredePay"
                                            {...form.getInputProps("andredePay")}
                                        >
                                            <Group mt="xs">
                                                <Radio value="Frau" label="Frau" />
                                                <Radio value="Herr" label="Herr" />
                                                <Radio value="Divers" label="Divers" />
                                            </Group>
                                        </Radio.Group>
                                    </>
                                )}

                                <TextInput
                                    id="namePay"
                                    name="namePay"
                                    type="text"
                                    label="Vorname"
                                    placeholder="Hier eingeben"
                                    {...form.getInputProps("namePay")}
                                />
                                <TextInput
                                    id="sunnamePay"
                                    name="surnamePay"
                                    type="text"
                                    label="Nachname"
                                    placeholder="Hier eingeben"
                                    {...form.getInputProps("surnamePay")}
                                />
                                <TextInput
                                    id="email"
                                    name="email"
                                    type="text"
                                    label="Deine E-Mail-Adresse"
                                    placeholder="Hier eingeben"
                                    {...form.getInputProps("email")}
                                />
                                {form.values.alreadyCustomer !== true && (
                                    <div>
                                        <TextInput
                                            id="address"
                                            name="address"
                                            type="text"
                                            label="Adresse"
                                            placeholder="Hier eingeben"
                                            {...form.getInputProps("address")}
                                        />
                                        <div className="flex gap-2 justify-between">
                                            <TextInput
                                                id="plz"
                                                name="plz"
                                                type="text"
                                                label="PLZ"
                                                placeholder="Hier eingeben"
                                                width="lg:w-[310px] md:w-[310px] w-[163.50px]"
                                                {...form.getInputProps("plz")}
                                            />
                                            <TextInput
                                                id="location"
                                                name="location"
                                                type="text"
                                                label="Ort"
                                                width="lg:w-[310px] md:w-[310px] w-[163.50px]"
                                                placeholder="Hier eingeben"
                                                {...form.getInputProps("location")}
                                            />
                                        </div>
                                        <p className="grow shrink basis-0 text-neutral-800 lg:text-lg text-base font-bold  leading-tight">
                                            Land
                                        </p>
                                        {/* <NativeSelect
                                            className="border-2 border-black"
                                            id="country"
                                            name="country"
                                            placeholder="Bitte auswählen"
                                            data={countries_list_german}
                                            {...form.getInputProps("country")}
                                        /> */}
                                        <Autocomplete
                                            className="border-2 border-black"
                                            id="country"
                                            name="country"
                                            placeholder="Bitte auswählen"
                                            data={countries_list_german}
                                            {...form.getInputProps("country")}
                                        />
                                    </div>
                                )}

                                <div className="lg:flex md:justify-between md:space-y-0 md:flex lg:space-y-0 space-y-5 justify-between">
                                    <Button
                                        backgroundColor={
                                            ButtonTransparent.args?.backgroundColor
                                        }
                                        size={ButtonDark.args?.size}
                                        border={ButtonTransparent.args?.border}
                                        text="Zurück"
                                        textColor={ButtonTransparent.args?.textColor}
                                        hasIcon={ButtonTransparent.args?.hasIcon}
                                        onClick={() => {
                                            setStep(1);
                                            prevStep();
                                        }}
                                        buttonType="button"
                                    />
                                    <Button
                                        backgroundColor={
                                            ButtonDark.args?.backgroundColor
                                        }
                                        border={ButtonDark.args?.border}
                                        size={ButtonDark.args?.size}
                                        text="Weiter"
                                        hasIcon={ButtonDark.args?.hasIcon}
                                        textColor={ButtonDark.args?.textColor}
                                        onClick={() => {
                                            setStep(3);
                                            nextStep();
                                        }}
                                        buttonType="button"
                                    />
                                </div>
                            </div>
                        </Stepper.Step>
                        <Stepper.Step onClick={() => setActive(2)}>
                            <div className="space-y-3 px-3">
                                <div className="text-neutral-800 text-2xl  lg:text-xl3 font-bold  leading-10">
                                    AGB und Widerruf
                                </div>
                                <Checkbox
                                    id="agreeCon"
                                    name="agreeCon"
                                    className="text-xl1"
                                    label="Ich bin mit den AGB und Widerrufsbelehrung einverstanden."
                                    {...form.getInputProps("agreeCon")}
                                    size="md"
                                    checked={form.values.agreeCon}
                                />
                                <Checkbox
                                    id="agree"
                                    name="agree"
                                    className="text-xl1"
                                    {...form.getInputProps("agree")}
                                    label="Wenn meine Bestellung die Ausführung Ihrer Dienstleistung in den nächsten Tagen verlangt, bin ich einverstanden und verlange ausdrücklich, dass Sie vor Ende der Widerrufsfrist mit der Ausführung der beauftragten Dienstleistung beginnen. Mir ist bekannt, dass ich bei vollständiger Vertragserfüllung durch Sie mein Widerrufsrecht verliere."
                                    size="md"
                                />
                                <div className="lg:flex md:flex md:justify-between md:space-y-0 space-y-3 lg:space-y-0 justify-between">
                                    <Button
                                        backgroundColor={
                                            ButtonTransparent.args?.backgroundColor
                                        }
                                        size={ButtonDark.args?.size}
                                        border={ButtonTransparent.args?.border}
                                        text="Zurück"
                                        textColor={ButtonTransparent.args?.textColor}
                                        onClick={() => {
                                            setStep(2);
                                            prevStep();
                                        }}
                                        buttonType="button"
                                    />
                                    <div className="space-y-2">
                                        <Button
                                            backgroundColor={
                                                MdButton.args?.backgroundColor
                                            }
                                            size={"min-h-15"}
                                            border={MdButton.args?.border}
                                            text="kostenpflichtig Bestellen"
                                            paddings="py-5 px-10"
                                            buttonType="submit"
                                        />
                                        <div className="text-black text-base font-normal  leading-tight">
                                            Deine Daten werden vertraulich behandelt.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Stepper.Step>
                    </Stepper>
                </form>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            title="Herzlichen Dank für deine Bestellung"
                            paragraphs={[
                                "Eine grossartige Entscheidung!",
                                "Du hast die Fernbegleitung erfolgreich bestellt und erhältst gleich eine Bestellbestätigung per E-Mail.",
                                "Gerne beginne ich an dem von dir gewählten Datum mit der Fernbegleitung.",
                                "Ich freue mich sehr, dass ich mit diesem Abo die Energiefelder und damit die innere Stärke aufbauen kann. Mit intakten Energien ist es viel einfacher neue Lösungsansätze zu finden. Verschiedene Prozesse wie der Aufbau von Eigenliebe, Selbstvertrauen, Belastbarkeit, Urvertrauen, usw. entwickeln sich. Das Leben wird leichter.",
                                "Ich möchte mich herzlich bei dir bedanken, dass du mir dein Vertrauen schenkst und  wünsche dir eine starke Zeit.",
                                "Liebe Grüsse",
                                "Rico Brunner",
                            ]}
                            paddings=""
                        />
                        <div className="flex justify-end py-5">
                            <Button
                                hasIcon={ButtonDark.args?.hasIcon}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                size={ButtonDark.args?.size}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                href="/"
                                as="a"
                            />
                        </div>
                    </>
                </InfoModal>
            </div>
        </>
    );
}
